import { Suspense, useContext } from 'react'
import { UIView } from '@uirouter/react'
import { useCurrentStateAndParams } from '@uirouter/react'
import Layout from 'layout'
import LoginPage from './LoginPage'
import Context from 'authService/Context'
import Getting from './LoginPage/Getting'

const Init: React.FC = () => {
  const { getting } = useContext(Context)

  const { params } = useCurrentStateAndParams()

  if (params.view === 'login') return <LoginPage />

  if (getting) return <Getting />

  return (
    <Suspense>
      <Layout>
        <UIView name="main" />
      </Layout>
    </Suspense>
  )
}

export default Init
